<template>
  <div class="">
      <div class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pdt-24 pdb-20">
        <div class="d-flex justify-content-center flex-column">
            <div class="t-center"><img src="/images/reward/no-data3.svg" alt="" class="w-44 h-44 mgx-auto"></div>
            <div class="t-color-content1 t-body3 l-spacing42 t-center pdl-16 pdr-16 mgt-24 font-r">
                {{$t('3057')}}
            </div>
        </div>
      </div>
    </div>
</template>

<script>
/**
 * 데이터 없음 컴포넌트(no data Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
  
};
</script>
<style scoped>
    .headerSection img {
      filter: blur(8px);
    }

    .headerSection:after {
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.4);
    }

    .headerContent {
      z-index: 999;
      position: absolute;
      content: "";
      width: 100%;
      top: 0px;
      left: 0;
    }

    .t-color-gray11 {
      color: #b0b5bc;
    }

    .headerContent .heading {
      line-height: 1.57;
    }

    .l-height-initial {
      line-height: initial !important;
    }

    .l-spacing39 {
      letter-spacing: -0.39 !important;
    }

    .header-strike-text {
      font-weight: 400;
    }

    .header-strike-text.withLine:after {
      content: '';
      position: absolute;
      width: calc(100% - 8px);
      height: 2px;
      background-color: #fc5356;
      ;
      left: 8px;
      top: 50%;
      transform: translateY(-50%);
    }

    .font-13 {
      font-size: 13px !important;
    }

    .customBtn {
      border: 1px solid #fff;
      border-radius: 11px;
    }

    .notification-icon {
      border-radius: 50%;
      border: 2px solid #fc5356;
    }
    .box-shadow-up{
      box-shadow: 1px -4px 6px rgba(0,0,0,0.1);
    }
</style>
